import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import img1 from "assets/img/img1.jpg";
import img2 from "assets/img/img2.jpg";
import img3 from "assets/img/img3.jpg";
import img4 from "assets/img/img4.jpg";
import img5 from "assets/img/img5.jpg";
import img6 from "assets/img/img6.jpg";
import three from "assets/img/three.png";
import four from "assets/img/four.png";
import five from "assets/img/five.png";
import six from "assets/img/six.png";
import seven from "assets/img/seven.png";
import eight from "assets/img/eight.jpg";
import nine from "assets/img/nine.png";
import ten from "assets/img/ten.png";

const Slider1 = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 1100,
    arrows: true, // Enable arrows
    spaceBetween: 20, // Space between slides
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
  };

  return (
    <section>
      <div className="relative gap-4">
        <Slider {...settings}>
          <div class="img-wrapper px-1">
            <img src={three} alt="Image 1" />
            <div class="img-hover-overlay">
              <i class="fab fa-instagram"></i>
            </div>
          </div>
          <div class="img-wrapper px-1">
            <img src={four} alt="Image 2" />
            <div class="img-hover-overlay">
              <i class="fab fa-instagram"></i>
            </div>
          </div>
          <div class="img-wrapper px-1">
            <img src={five} alt="Image 3" />
            <div class="img-hover-overlay">
              <i class="fab fa-instagram"></i>
            </div>
          </div>
          <div class="img-wrapper px-1">
            <img src={six} alt="Image 4" />
            <div class="img-hover-overlay">
              <i class="fab fa-instagram"></i>
            </div>
          </div>
          <div class="img-wrapper px-1">
            <img src={seven} alt="Image 5" />
            <div class="img-hover-overlay">
              <i class="fab fa-instagram"></i>
            </div>
          </div>
          <div class="img-wrapper px-1">
            <img src={nine} alt="Image 6" />
            <div class="img-hover-overlay">
              <i class="fab fa-instagram"></i>
            </div>
          </div>
        </Slider>
      </div>
    </section>
  );
};

const CustomNextArrow = (props) => {
  const { onClick } = props;
  return (
    <button
      className="custom-arrow-next text-black bgarrows h-8 w-8 rounded-md absolute top-1/2 right-0 transform -translate-y-1/2"
      onClick={onClick}
    >
        ❯ {/* Right arrow */}
    </button>
  );
};

const CustomPrevArrow = (props) => {
  const { onClick } = props;
  return (
    <button
      className="custom-arrow-prev text-black bgarrows h-8 w-8 rounded-md absolute left-2 top-1/2 transform -translate-y-1/2 z-50  shadow-md"
      onClick={onClick}
    >
       ❮ {/* Left arrow */}
    </button>
  );
};

export default Slider1;
